import { EAlertType } from 'shared/types/microfrontendsAPI';
import { TThunkAction } from 'shared/types/redux';

export { EAlertType };

export interface IRequestAuthenticationParameters {
  /**
   * Алерт в модальном окне авторизации
   */
  alert?: EAlertType | null;
  /**
   * Источник открытия модального окна, используется в аналитике
   */
  source?: string | null;
}

/**
 * Открывает модальное окно авторизации через API микрофронтенда шапки.
 *
 * После успешной авторизации шапка сама перезагружает страницу (autoRefresh).
 */
export function requestAuthentication({
  alert = null,
  source = null,
}: IRequestAuthenticationParameters = {}): TThunkAction<void> {
  return (_dispatch, _getState, context) => {
    const { microfrontendsAPI } = context;

    if (!microfrontendsAPI) {
      return;
    }

    void microfrontendsAPI.header.openAuthModal({
      alert,
      autoRefresh: true,
      source,
      useDefaultView: false,
      viewData: null,
    });
  };
}
